// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_promise from "../../../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as AuthUtils$PorterinFeature from "../../../../domain/helpers/AuthUtils.mjs";
import * as AuthConfig$PorterinFeature from "../../../../domain/config/AuthConfig.mjs";
import * as CookieUtils$PorterinFeature from "../../../../../fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as Lib$PorterinFusionkitSentry from "../../../../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as AuthRepoManager$PorterinFeature from "../../../../domain/repo/AuthRepoManager.mjs";
import * as CustomErrorUtils$PorterinFeature from "../../../../../order-review/domain/helpers/CustomErrorUtils.mjs";
import * as OtpValidationFormHelper$PorterinFeature from "../../../../domain/helpers/OtpValidationFormHelper.mjs";
import * as FareEstimateAnalyticsHelper$PorterinFeature from "../../../../../fare-estimate-v1/domain/helpers/FareEstimateAnalyticsHelper.mjs";
import * as FareEstimateResultFormHelper$PorterinFeature from "../../../../../../shared/core/helpers/FareEstimateResultFormHelper.mjs";

function initialFormState(param) {
  return {
          otp: ""
        };
}

function onFormSubmit(close_on_successOpt, output, callbacks, setResponse, close_modal, user, set_user, set_is_authenticated, redirection_url, router, agreed_docs) {
  var close_on_success = close_on_successOpt !== undefined ? close_on_successOpt : true;
  var form_data = {
    otp: output.otp
  };
  AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
  var webTrackingId = CookieUtils$PorterinFeature.webTrackingIdSafely(undefined);
  FareEstimateAnalyticsHelper$PorterinFeature.isNewUserSignup(AuthUtils$PorterinFeature.mobile(user));
  var onOtpValidationSucess = function (data) {
    CookieUtils$PorterinFeature.setCookieWithExpiration("auth-token", data.auth_token, AuthConfig$PorterinFeature.cookie_expiration_days);
    CookieUtils$PorterinFeature.setCookieWithExpiration("mobile", data.mobile, AuthConfig$PorterinFeature.cookie_expiration_days);
    Curry._1(set_user, {
          auth_token: data.auth_token,
          mobile: data.mobile,
          name: AuthUtils$PorterinFeature.name(user),
          requirement_type: AuthUtils$PorterinFeature.requirementType(user),
          email: AuthUtils$PorterinFeature.email(user),
          whatsapp_consent: AuthUtils$PorterinFeature.whatsappConsent(user)
        });
    Curry._1(set_is_authenticated, true);
    Curry._1(callbacks.notifyOnSuccess, undefined);
    setTimeout((function (param) {
            if (close_on_success) {
              Curry._1(close_modal, undefined);
            }
            var match = router.pathname;
            if (match === "/fare-estimate") {
              return JsBindings$PorterinUtils.redirect(redirection_url);
            }
            
          }), 500);
  };
  var onOtpValidationFailure = function (error) {
    var match = CustomErrorUtils$PorterinFeature.getErrorEntity(error);
    var exit = 0;
    if (typeof match === "number" || match.TAG !== /* UnprocessedEntity */1) {
      exit = 1;
    } else {
      Curry._1(setResponse, (function (param) {
              return {
                      TAG: /* Error */1,
                      _0: ErrorUtils$Catalyst.resolveError(error)
                    };
            }));
    }
    if (exit === 1) {
      Curry._1(setResponse, (function (param) {
              return {
                      TAG: /* Error */1,
                      _0: ErrorUtils$Catalyst.resolveError(error)
                    };
            }));
    }
    Curry._1(callbacks.notifyOnFailure, error);
  };
  Js_promise.$$catch((function (error) {
          Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, error.toString());
          return Promise.resolve(undefined);
        }), Js_promise.then_((function (customer_exist_flag) {
              var exit = 0;
              if (customer_exist_flag !== undefined && customer_exist_flag) {
                OtpValidationFormHelper$PorterinFeature.customerOtpValidation(webTrackingId, user, form_data.otp, agreed_docs, undefined, undefined, onOtpValidationSucess, onOtpValidationFailure);
              } else {
                exit = 1;
              }
              if (exit === 1) {
                var referralCode = Js_dict.get(router.query, "referral_code");
                var geoRegionId = Js_dict.get(router.query, "geo_region_id");
                OtpValidationFormHelper$PorterinFeature.customerOtpValidation(webTrackingId, user, form_data.otp, agreed_docs, referralCode, geoRegionId, onOtpValidationSucess, onOtpValidationFailure);
              }
              return Promise.resolve(undefined);
            }), FareEstimateResultFormHelper$PorterinFeature.getCustomerExistInfo(AuthUtils$PorterinFeature.mobile(user))));
}

export {
  initialFormState ,
  onFormSubmit ,
}
/* JsBindings-PorterinUtils Not a pure module */
